module.exports = __webpack_public_path__ + "img/leftback.1e88cab2.png";